import httpClient from '@/libs/http-client'
import { readABTarget } from '@/libs/heatmap-v2/followup'

export function getList (aid) {
  const url = `/ab/get_list/${aid}`

  return httpClient.get(url).then(response => {
    return response.data.result
  })
}

export function addPage (values) {
  const url = `/ab/add_page`
  return httpClient.post(url, values).then(response => {
    return response.data.result
  })
}

export function addText (values) {
  const url = `/ab/add_text`
  return httpClient.post(url, values).then(response => {
    return response.data.result
  })
}

export function modifyText (values) {
  const url = `/ab/modify_text`
  return httpClient.post(url, values).then(response => {
    return response.data.result
  })
}

export function deleteText (values) {
  const url = `/ab/delete_text`
  return httpClient.post(url, values).then(response => {
    return response.data.result
  })
}

export function getTextList (values) {
  const url = `/ab/get_text_list`
  return httpClient.post(url, values).then(response => {
    return response.data.result
  })
}

export function modifyPage (values) {
  const url = `/ab/modify_page`

  return httpClient.post(url, values).then(response => {
    return response.data.result
  })
}

export function deletePage (values) {
  const url = `/ab/delete_page`

  return httpClient.post(url, values).then(response => {
    return response.data.result
  })
}

export function addABTarget (values) {
  const url = `/ab/target/add`

  return httpClient.post(url, values).then(response => {
    return response.data.result
  })
}

export function modifyABTarget (values) {
  const url = `/ab/target/modify`

  return httpClient.post(url, values).then(response => {
    return response.data.result
  })
}

export function getABTargetList (abaid) {
  const url = `/ab/target/list/${abaid}`

  return httpClient.get(url).then(response => {
    return response.data.result
  })
}

export function getABTargetResult (values) {
  const url = `/ab/target/get_data`

  return readABTarget(values, () => httpClient.post(url, values).then(response => {
    return response.data.result
  }))
}
